module.exports = __webpack_public_path__ + "img/DROP-9-820x1024.e44872dd.png";